import { gql } from '@apollo/client'

export const REQUEST_BASIC_PROPS = gql`
  fragment RequestBasicProps on Request {
    id
    date
    company
    projectName
    licenseUser
    style
    vocals
    tempo
    language
    reference
    media
    paidMedia
    projectType
    territory
    country
    licensingTerm
    budget
    typeOfUse
    typeOfLicense
    extraInfo
    tracks {
      slug
      artist
      name
      image
      price
      purchased
      purchasedOn
      purchasedId
    }
    messagesOpenedOn
    messages {
      time
      id
      content
      author
    }
  }
`
export const PURCHASED_BASIC_PROPS = gql`
  fragment PurchasedBasicProps on Purchased {
    id
    date
    refRequestType
    refRequestId
    trackId
    trackName
    trackArtist
    trackSlug
    trackPrice
    licensor
    projectName
    licensorAddress
    transactionId
    previewFile
    paymentMethod
    address
    useLength
    cutDown
    syncId
  }
`
